import { useCallback, useState } from 'react';
import { useSendWireDisbursementMutation } from 'API/order/escrow/WireDisbursementAPI';
import currencyJs from 'currency.js';

interface UseSendWireDisbursementProps {
  availableAmountDollars: number;
  orderId: string;
  onTransactionUpdate: () => void;
}

interface WireDisbursement {
  id: string;
  amountCents: number;
}

export const useSendWireDisbursement = ({
  availableAmountDollars,
  orderId,
  onTransactionUpdate,
}: UseSendWireDisbursementProps) => {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [sendWireId, setSendWireId] = useState<string | undefined>(undefined);
  const [onSendWire] = useSendWireDisbursementMutation();

  const sendWireDisbursement = useCallback(
    async (wirePush: WireDisbursement) => {
      setSendWireId(wirePush.id);
      setShowWarningModal(false);
      await onSendWire({ wireId: wirePush.id, orderId });
      onTransactionUpdate();
      setSendWireId(undefined);
    },
    [onSendWire, onTransactionUpdate, orderId, setSendWireId, setShowWarningModal]
  );

  const onSendWireDisbursement = useCallback(
    async (wirePush: WireDisbursement) => {
      if (wirePush.amountCents > currencyJs(availableAmountDollars).multiply(100).value) {
        setShowWarningModal(true);
      } else {
        await sendWireDisbursement(wirePush);
      }
    },
    [sendWireDisbursement, availableAmountDollars, setShowWarningModal]
  );

  return {
    showWarningModal,
    setShowWarningModal,
    sendWireId,
    onSendWireDisbursement,
  };
};
